import React from 'react';
import { Box, Fade, lighten, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export const ThreadTagsLabel = ({
    tags,
    size = 'sm',
}: {
    tags: any;
    size?: 'sm' | 'lg';
}) => {
    const theme = useTheme();
    return (
        <Fade in={true} unmountOnExit>
            <Box
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    gap: 5,
                }}
            >
                {tags.map(({ _id, name, color, icon }: any) => (
                    <Box
                        key={_id}
                        style={{
                            backgroundColor: color,
                            border: `1px solid ${lighten(color, 0.2)}`,
                            padding: size === 'lg' ? '6px 16px' : '3px 10px',
                            borderRadius: size === 'lg' ? 30 : 15,
                        }}
                    >
                        <Typography
                            variant="caption"
                            style={{
                                fontSize: size === 'lg' ? 14 : 12,
                                color: theme.palette.getContrastText(color),
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                            }}
                        >
                            {icon} {name}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Fade>
    );
};
